<script>
    import Select from "svelte-select/Select.svelte";

    import { asaAllItemsList } from "../../../../../stores";
    import {
        searchAsaItems,
        updateConsultItems,
        updateModifierItems,
        updateNonCategoryItems,
        updateProcedureItems,
        updateSurgeryItems,
    } from "../../../helpers/asaHelper.svelte";

    export let itemProps = {},
        selectedItems = [],
        holidaysInState = [],
        infoTypesMap = new Map(),
        modifierMap = new Map(),
        updateItems = () => {},
        openNotification = () => {};

    $: if ($asaAllItemsList.length && infoTypesMap.size) _syncSpecialItems();

    let searchItemResult = {};

    let defaultProcedureItems = [];

    const loadAsaItems = async (searchText) => {
        if (!searchText) return [];

        let res = await searchAsaItems(searchText);

        if (!res || !res.length) return [];

        const result = [];

        res.filter(
            (item) => !selectedItems.some((sItem) => sItem.id == item.id),
        ).map((item) =>
            result.push({
                ...item,
                displayName: getAsaOptionLabel(item),
            }),
        );

        return result;
    };

    const getAsaOptionLabel = (option) =>
        `${option.itemCode} ${
            option.subItemCode != "0" ? `(${option.subItemCode})` : ""
        } - ${
            option.infoShortTitle ? option.infoShortTitle : option.description
        }`;

    const handleChangeItem = (item, actionType = "add") => {
        switch (item.infoType) {
            case "Consults":
            case "Cardiac":
                updateItems(updateConsultItems(item, selectedItems, itemProps));
                break;
            case "Surgery":
                updateItems(
                    updateSurgeryItems(
                        item,
                        selectedItems,
                        itemProps,
                        openNotification,
                    ),
                );
                break;
            case "Modifiers":
                updateItems(
                    updateModifierItems(
                        item,
                        selectedItems,
                        modifierMap,
                        openNotification,
                    ),
                );
                break;
            case "AdditionalProcedures":
                const resArr = updateProcedureItems(
                    item,
                    selectedItems,
                    itemProps,
                    defaultProcedureItems,
                    holidaysInState,
                    true,
                );
                updateItems(resArr);

                const { billingType } = itemProps;

                // sync neuraxialType from deleting procedure item
                if (billingType == 2 && actionType == "delete") {
                    const insertionItems = ["CV120", "CV122", "CV123", "CV124"];
                    const topUpItems = ["CV125", "CV126"];

                    const hasInsertionItemsLeft = resArr.some((item) =>
                        insertionItems.includes(item.itemCode),
                    );
                    const hasTopUpItemsLeft = resArr.some((item) =>
                        topUpItems.includes(item.itemCode),
                    );

                    itemProps.neuraxialType =
                        hasInsertionItemsLeft && hasTopUpItemsLeft
                            ? 3
                            : hasTopUpItemsLeft
                              ? 2
                              : hasInsertionItemsLeft
                                ? 1
                                : 0;
                }
                break;
            default:
                updateItems(updateNonCategoryItems(item, selectedItems));
                break;
        }

        clearSelectItem();
    };

    const clearSelectItem = () => (searchItemResult.item = null);

    // HELPER FUNCTIONS
    const _syncSpecialItems = () => {
        defaultProcedureItems = infoTypesMap.get("AdditionalProcedures");
    };
</script>

<div class="flex flex-col gap-y-4 p-4">
    <div class="flex flex-1">
        <Select
            bind:value={searchItemResult.item}
            class="flex flex-1 max-h-[35px] rounded-full"
            loadOptions={loadAsaItems}
            itemId="id"
            label="displayName"
            on:select={() => handleChangeItem(searchItemResult.item)}
            on:clear={clearSelectItem}
            noOptionsMessage="No ASA item found"
            placeholder="Search ASA item"
        />
    </div>

    {#if selectedItems.length}
        <div class="flex flex-1 flex-wrap items-center gap-x-2">
            <p>Selected ASA items:</p>
            {#each selectedItems as item}
                <div
                    class="flex cursor-default bg-secondary min-w-[36px] rounded-lg text-[#fff] relative"
                >
                    <p class="px-2 py-1 z-[0]">{item.itemCode}</p>
                    <div
                        class="absolute text-[#fff] cursor-pointer w-[20px] top-[-5px] right-[-5px] bg-red-600/50 hover:bg-red-600 rounded rounded-lg px-1 z-[1] text-xs text-center"
                        on:click|preventDefault={() =>
                            handleChangeItem(item, "delete")}
                    >
                        X
                    </div>
                </div>
            {/each}
        </div>
    {/if}
</div>
